var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report__header primary elevation-2"},[_c('div',{staticClass:"que-content-max-width my-0 pa-0"},[_c('booking-report-meta')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }